module.exports = __webpack_public_path__ + "static/media/upgrade_intent.31d79d36.png";